import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-context';
import { Button } from '@/components/ui/button';

export default function StandardNav() {
  const { user } = useAuth();
  const navigate = useNavigate();
  
  return (
    <nav className="hidden md:flex items-center gap-6">
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/dashboard')}
      >
        Dashboard
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate(`/profile/${user?.id}`)}
      >
        Profile
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/planner')}
      >
        Planner
      </Button>
      <Button 
        variant="ghost" 
        className="text-sm font-medium hover:text-primary transition-colors" 
        onClick={() => navigate('/loops')}
      >
        Loops
      </Button>
    </nav>
  );
}